import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import DriverComponent from '../../gha/manageOrders/manualEntry/components/DriverComponent';

import DriverInfoModel from '../../../models/GhaManualEntryDriverInfo';
import GhaDock from '../../../models/GhaDock';

import style from './awbReturn.module.css';
import commonStyles from '../../common/common.module.css';
import ManualEntryAdd from '../../../models/ManualEntryAdd';
import ReturnReasonComponent from './components/ReturnReasonComponent';
import ReturnChargesComponent from './components/ReturnChargesComponent';
import PaymentInfoComponent from './components/PaymentInfoComponent';
import CartItem from '../../../models/CartItem';
import { ReturnReason } from '../../../models/ReturnAwb';
import AlternativePaymentOptions from '../../../models/PaymentOptions';
import { Fade, Grid, Typography } from '@material-ui/core';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      margin: '10px 20px',
      fontSize: '13px',
    },
    dialogContent: {
      padding: '24px'
    },
    close: {
      fontSize: '27px'
    },
    '@media (max-width:480px)': {
      dialogPaper: {
        width: '90%'
      },
    },
  });

interface AwbReturnModalProps {
  classes: any;
  modalOpen: boolean;
  handleCloseModal: (type: string) => void;
  driverInfo: DriverInfoModel;
  selectedDock: number | null;
  docks: Array<GhaDock>;
  handleChange: (type: string, event: any) => void;
  handleSubmit: () => void;
  errors: DriverInfoModel;
  returnErrors: ReturnReason;
  onClick: (event: any) => void;
  maskon:() => void;
  delivererType: string;
  isAddMode: ManualEntryAdd;
  handleOpenModal: (type: string) => void;
  returnDetails: ReturnReason;
  cartItem: CartItem | undefined;
  returnCharges: string;
  paymentOptions: AlternativePaymentOptions;
  paymentType: string;
  paymentInfoSelect: string;
  showText: boolean;
};

const awbReturnModal = (props: AwbReturnModalProps) => {

  const { classes } = props;
  const titleText: string =  'Capture';
  const typeText: string = 'Return';
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleCloseModal('awbReturn') }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'xl' }
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: props.classes.dialogPaper }}
    >
    <DialogTitle id="form-dialog-title" className={ commonStyles.dialogTitleRoot }>
      <div className={ commonStyles.dialogTitle }>
        <span className={ commonStyles.colorPrimary }>{ titleText } { typeText } Details</span>
        <IconButton aria-label="Close" onClick={ () => props.handleCloseModal('awbReturn') } className={ classes.close }>
          <CloseIcon color='primary' fontSize='inherit'/>
        </IconButton>
      </div>
      <hr />
    </DialogTitle>
    <DialogContent className={ classes.dialogContent }>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={4} className={ style.returnReason }> 
          <ReturnReasonComponent
            returnDetails={ props.returnDetails }
            handleChange={ props.handleChange }
            returnErrors={ props.returnErrors }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={ style.returnCharges }>
          <ReturnChargesComponent
            handleOpenModal={ props.handleOpenModal }
            cartItem={ props.cartItem }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={ style.returnPaymentInfo }>
          <PaymentInfoComponent
            handleChange={ props.handleChange }
            returnCharges={ props.returnCharges }
            paymentInfoSelect={ props.paymentInfoSelect }
            paymentOptions={ props.paymentOptions }
            paymentType={ props.paymentType }
          />
        </Grid>
        <Grid item xs={12} className={ style.driverInfo }>
          <DriverComponent 
          driverInfo={ props.driverInfo }
          selectedDock={ props.selectedDock }
          docks={ props.docks }
          handleChange={ props.handleChange }
          errors={ props.errors }
          onClick={ props.onClick }
          maskon={props.maskon }
          delivererType={ props.delivererType }
          disabled={ false }
          />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Fade in={props.showText} timeout={ 1000 }>
        <Typography variant="subtitle1" gutterBottom style={ { color: 'green' } }>
          Return Order Created
        </Typography>
      </Fade>
      <Button 
        className={ classes.submitBtn }
        variant="contained" 
        color="primary" 
        onClick={ props.handleSubmit }
      >
      { props.showText ? "Go to manage pickups" : "Update Return Order" }
      </Button>
    </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isAddMode: state.manualEntryAdd.isAddMode
  }
}

export default withStyles(styles)(connect(mapStateToProps, {})(awbReturnModal));
